import { z } from 'zod';

/**
 * リリースプラン作成データタブの検索パラメータ。
 *
 * `operationTaskInstanceId` は表示対象タスク（SelectTargetTickets /
 * SelectTargetValues）のインスタンス ID。初回マウント時に InProgress の
 * 選択タスクを URL へ注入する。
 */
export const SearchSchema = z.object({
  operationTaskInstanceId: z.string().optional(),
  freeText: z.string().optional(),
  pageIndex: z.number().optional(),
  pageSize: z.number().optional(),
  sortColumn: z.string().optional(),
  sortOrder: z.enum(['asc', 'desc']).optional()
});